"use client";
import { isProduction } from "@/lib/appEnv";
import { useEffect } from "react";

const DelayedScriptLoader = () => {
  const shouldLoadScripts = process.env.NODE_ENV != "development" && isProduction();
  
  useEffect(() => {
    const delay = setTimeout(() => {
      if (!shouldLoadScripts) return;
      // Google Tag Manager script
      const gScript = document.createElement("script");
      gScript.src = "https://analytics.ahrefs.com/analytics.js";
      gScript.setAttribute("data-key", "RzZPJEeZpewCwcSTTNkedw");
      gScript.async = true;

      document.head.appendChild(gScript);

      const script = document.createElement("script");
      script.src = "https://www.googletagmanager.com/gtag/js?id=G-6PHKJ32T5F";

      script.async = true;
      document.head.appendChild(script);

      // GTM Initialization script
      const gtmScript = document.createElement("script");
      gtmScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-KMKQP37');
      `;
      document.head.appendChild(gtmScript);
    }, 3000); // Delay in milliseconds (3 seconds)

    return () => {
      clearTimeout(delay); // Cleanup timeout on component unmount
    };
  }, [shouldLoadScripts]);

  return null;
};

export default DelayedScriptLoader;
